import { Injectable, OnDestroy } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subscription, take } from "rxjs";
import { TOAST_CONFIG } from "./service.constant";

export type ToastType = "success" | "error";

@Injectable({
  providedIn: "root",
})
export class ToastrBridgeService implements OnDestroy {
  private isToastVisible = false;
  private toastSubscriptions: Subscription[] = [];
  public TOAST_CONFIG = TOAST_CONFIG

  constructor(private toastr: ToastrService) {}

  show(type: ToastType, message: string): void {
    // Validate input parameters
    if (
      (type !== "success" && type !== "error") ||
      typeof message !== "string" ||
      !message.trim()
    ) {
      console.warn("[Toastr] Invalid toast type or message.");
      return;
    }

    // Prevent duplicate notifications
    if (this.isToastVisible) {
      return;
    }

    this.isToastVisible = true;

    const options = {
      positionClass: TOAST_CONFIG.POSITION,
      closeButton: true,
      timeOut: TOAST_CONFIG.TIMEOUT_MS,
      extendedTimeOut: TOAST_CONFIG.EXTENDED_TIMEOUT_MS,
      onActivateTick: true,
    };

    try {
      const toast =
        type === "success"
          ? this.toastr.success(message, "", options)
          : this.toastr.error(message, "", options);

      let subscription: Subscription;

      subscription = toast.onHidden.pipe(take(1)).subscribe(() => {
        this.isToastVisible = false;

        // Remove completed subscription
        const index = this.toastSubscriptions.indexOf(subscription);

        if (index !== -1) {
          this.toastSubscriptions.splice(index, 1);
        }
      });

      this.toastSubscriptions.push(subscription);
    } catch (error) {
      this.isToastVisible = false;
      console.error("[Toastr] Failed to display notification:", error);
    }
  }

  ngOnDestroy(): void {
    // Clean up remaining subscriptions
    this.toastSubscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });

    this.toastSubscriptions = [];
    this.isToastVisible = false;
  }
}
